/**
 * A sub-view of the refine sheet's internal view stack. Sections are keyed
 * by title (the existing unique key for modal sections) rather than by
 * object, so aggregation refreshes never leave the stack pointing at a
 * stale section — the live section is resolved on render.
 */
export type RefineSubView =
    | { type: 'section'; sectionTitle: string; isFacet: boolean }
    | { type: 'moreFilters' };

/** Title of the drill-in row that gathers the long-tail filter sections. */
export const MORE_FILTERS_TITLE = 'More filters';
